// extracted by mini-css-extract-plugin
export default {"btnRow":"LandingPage_btnRow__gYT-G","navLink":"LandingPage_navLink__CaM2K"};